module.exports = __webpack_public_path__ + "096958315ef1a285afdcac48f8c0868b.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/mobile/m-index-img8.jpg
// module id = 232
// module chunks = 3